var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-admin" }, [
    _c("div", { staticClass: "page-titles border-bottom" }, [
      _c("h3", [_vm._v("Bio Test")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-info btn-sm pull-right",
          on: {
            click: function ($event) {
              return _vm.$router.push("/account/transcripts")
            },
          },
        },
        [
          _c("i", { staticClass: "fas fa-list" }),
          _vm._v(" "),
          _c("span", { staticClass: "d-none d-sm-inline" }, [
            _vm._v(_vm._s(_vm.trans("bio.bio_list"))),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-0",
        staticStyle: { "font-size": "0.75em" },
      },
      [
        _c("div", { staticStyle: { width: "50%", float: "left" } }, [
          _c(
            "div",
            {
              staticClass: "row",
              staticStyle: {
                background: "#fff",
                "border-radius": "20px",
                padding: "20px 20px 40px",
              },
            },
            [
              _c("div", { staticClass: "col-12 col-sm-12" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-sm-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.bioForm.name,
                            expression: "bioForm.name",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", value: "", name: "name" },
                        domProps: { value: _vm.bioForm.name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.bioForm, "name", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.bioForm.title,
                            expression: "bioForm.title",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", value: "", name: "title" },
                        domProps: { value: _vm.bioForm.title },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.bioForm, "title", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.bioForm.company,
                            expression: "bioForm.company",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", value: "", name: "company" },
                        domProps: { value: _vm.bioForm.company },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.bioForm,
                              "company",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.bioForm.company_hq,
                            expression: "bioForm.company_hq",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", value: "", name: "company_hq" },
                        domProps: { value: _vm.bioForm.company_hq },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.bioForm,
                              "company_hq",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.bioForm.investor_type,
                            expression: "bioForm.investor_type",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          value: "",
                          name: "investor_type",
                        },
                        domProps: { value: _vm.bioForm.investor_type },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.bioForm,
                              "investor_type",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.bioForm.investor_country,
                            expression: "bioForm.investor_country",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          value: "",
                          name: "investor_country",
                        },
                        domProps: { value: _vm.bioForm.investor_country },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.bioForm,
                              "investor_country",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(6),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.bioForm.asset_class,
                            expression: "bioForm.asset_class",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", value: "", name: "asset_class" },
                        domProps: { value: _vm.bioForm.asset_class },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.bioForm,
                              "asset_class",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        staticStyle: { "margin-bottom": "30px" },
                      },
                      [
                        _vm._m(7),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.bioForm.investment_location,
                              expression: "bioForm.investment_location",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            value: "",
                            name: "investment_location",
                          },
                          domProps: { value: _vm.bioForm.investment_location },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.bioForm,
                                "investment_location",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-12" }, [
                    !_vm.is_run
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-info",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.sendText.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("Start Bio Generation")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.is_run
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-info",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.resetText.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("Reset")]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: { width: "50%", float: "left", padding: "0 0 0 40px" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#fff",
                  "border-radius": "20px",
                  padding: "40px",
                  "min-height": "400px",
                },
              },
              [
                _vm.is_run
                  ? _c(
                      "div",
                      [
                        _c("img", {
                          staticStyle: {
                            "max-width": "400px",
                            width: "80%",
                            margin: "50px auto 0",
                            opacity: "0.2",
                            display: "block",
                          },
                          attrs: { src: "/images/11-38-42-66_512.webp" },
                        }),
                        _vm._v(" "),
                        _c("center", [
                          _vm._v("The AI process is running. Please wait."),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.is_ready
                  ? _c("div", { staticClass: "pta-ai-results" }, [
                      _c("div", { domProps: { textContent: _vm._s(_vm.bio) } }),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticStyle: { clear: "left" } }),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "" } }, [
      _vm._v("Name"),
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "12px",
            display: "inline-block",
            "padding-left": "10px",
          },
        },
        [_vm._v("(e.g. John Doe)")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "" } }, [
      _vm._v("Title"),
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "12px",
            display: "inline-block",
            "padding-left": "10px",
          },
        },
        [_vm._v("(e.g. Senior Developer)")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "" } }, [
      _vm._v("Company"),
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "12px",
            display: "inline-block",
            "padding-left": "10px",
          },
        },
        [_vm._v("(e.g. Tech Solutions)")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "" } }, [
      _vm._v("Company headquarter"),
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "12px",
            display: "inline-block",
            "padding-left": "10px",
          },
        },
        [_vm._v("(e.g. San Francisco, USA)")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "" } }, [
      _vm._v("Investor type"),
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "12px",
            display: "inline-block",
            "padding-left": "10px",
          },
        },
        [_vm._v("(e.g. Institutional Investor)")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "" } }, [
      _vm._v("Investor country"),
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "12px",
            display: "inline-block",
            "padding-left": "10px",
          },
        },
        [_vm._v("(e.g. USA)")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "" } }, [
      _vm._v("Asset class"),
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "12px",
            display: "inline-block",
            "padding-left": "10px",
          },
        },
        [_vm._v("(e.g. Technology)")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "" } }, [
      _vm._v("Investment location"),
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "12px",
            display: "inline-block",
            "padding-left": "10px",
          },
        },
        [_vm._v("(e.g. Global)")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }